const styles = (theme) => ({
  popOver: {
    minWidth: 270,
    maxHeight: "40%"
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.ModalBGColor,
  },
  kpiBoxContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 8,
    marginBottom: 12,
  },
  customerName: {
    fontWeight: 500,
    fontSize: 11,
    lineHeight: "15px",
    color: theme.dispatchPanelLabelValueColor,
  },
  updatedBy: {
    fontWeight: 400,
    fontSize: 10,
    lineHeight: "14px",
    color: theme.iconColor,
  },
  optymizerLabel: {
    fontWeight: 500,
    fontSize: theme.dispatchCardTextFontSize,
    lineHeight: "14px",
    color: theme.ToggleIconColor,
    display: "flex",
    paddingTop: 10,
    borderTop: `1px solid ${theme.AppBGColor}`,
  },
  fromCustomerName: {
    fontWeight: 600,
    fontSize: theme.textFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
    display: "flex",
    paddingBottom: 8,
    borderBottom: `1px solid ${theme.AppBGColor}`,
  },
  dividerStyle: {
    borderRight: `1px solid ${theme.AppBGColor}`,
    margin: "1 6 0 6",
  },
  expandLabel: {
    fontWeight: 500,
    fontSize: theme.dispatchCardTextFontSize,
    lineHeight: "14px",
    color: theme.dispatchPanelLabelValueColor,
  },
  historyContainer: {
    display: "flex",
    flexDirection: "column",
  },
  historyKpiContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  rootContent: {
    paddingBottom: 0,
  },
  childContent: {
    paddingTop: 0,
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  expandSection: {
    justifyContent: "space-between",
    paddingLeft: 12,
  },
  expandButton: {
    padding: 3,
    color: theme.gridTextColor
  },
  loader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    backgroundColor: theme.ModalBGColor,
    zIndex: 999,
    flex: 1,
    position: "absolute",
  },
  errorMessage: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: 184,
    backgroundColor: theme.ModalBGColor,
    flex: 1,
    fontSize: theme.textFontSize,
    color: theme.warningTextColor
  },
  negativeParentKpi: {
    color: theme.error,
    backgroundColor: theme.violationsBackgroundColor,
    lineHeight: "16px",
    fontWeight: 500,
    fontSize: theme.textFontSize,
    padding: "2px 6px 2px 6px",
    borderRadius: "2px",
  },
  positiveParentKpi: {
    color: theme.successTextColor,
    backgroundColor: theme.StatusWrapperColor,
    lineHeight: "16px",
    fontWeight: 500,
    fontSize: theme.textFontSize,
    padding: "2px 6px 2px 6px",
    borderRadius: "2px",
  },
  unitStyle: {
    marginLeft: 2,
  },
  negativeChildKpi: {
    color: theme.ErrorMessageColor,
    fontSize: theme.dispatchCardTextFontSize,
    lineHeight: "14px",
    fontWeight: 500,
    padding: "2px 0px 2px 0px",
    borderRadius: "2px",
  },
  positiveChildKpi: {
    color: theme.palette.primary.main,
    fontSize: theme.dispatchCardTextFontSize,
    lineHeight: "14px",
    fontWeight: 500,
    padding: "2px 0px 2px 0px",
    borderRadius: "2px",
  },
});

export default styles;
